import { atom } from "jotai";
import type { ISearchIssuersQuery } from "lib/graphql/queries/__generated__/SearchIssuersQuery.generated";

export type IssuerSelectIssuerNode = ISearchIssuersQuery["searchIssuers"][number];

export const ISSUER_SEARCH_RESULTS_ATOM = atom<IssuerSelectIssuerNode[]>([]);
export const SELECTED_ISSUERS_ATOM = atom<IssuerSelectIssuerNode[]>([]);
